
import { useState } from 'react';

/**
 * Hook for handling client filtering and status normalization
 */
export const useClientFiltering = () => {
  const [filterStatus, setFilterStatus] = useState<string>("all");

  // Normalize status values for UI consistency
  const normalizeStatus = (status: string) => {
    if (status === 'pending_verification') return 'pending';
    if (status === 'verified') return 'approved';
    return status;
  };
  
  // Denormalize status values for DB consistency
  const denormalizeStatus = (status: string) => {
    if (status === 'pending') return 'pending_verification';
    if (status === 'approved') return 'verified';
    return status;
  };

  // Apply filters to get the correct lists
  const getFilteredRequests = (requests: any[], statusFilter: string) => {
    let filtered = [...requests];
    
    // First apply active/inactive filter
    if (statusFilter === 'active') {
      filtered = filtered.filter(req => req.is_active);
    } else if (statusFilter === 'inactive') {
      filtered = filtered.filter(req => !req.is_active);
    }
    
    return filtered;
  };

  return {
    filterStatus,
    setFilterStatus,
    normalizeStatus,
    denormalizeStatus,
    getFilteredRequests
  };
};
